import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextMedium, space2, space6 } = theme();

  return StyleSheet.create({
    modalContent: {
      paddingHorizontal: space6,
    },
    optionText: {
      color: colorTextMedium,
      marginBottom: space6,
    },
    wrapper: {
      marginBottom: space2,
    },
  });
};

export { style };
